

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar/route', '../../guest/currencyConversion/route'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-add-card.route', ['squid', 'xo-multistep-signup-add-card.directive', 'hermes.page.xo-sidebar.route']).factory('$MultistepSignupAddCardRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupAddCardRoute', {
            name: 'multistepsignupaddcard',

            directive: 'xo-multistep-signup-add-card',

            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'multistepSignupModel'
                }
            }, {
                name: '$CurrencyConversionOptionsRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'multistepSignupModel',
                    'is-pre-plan': 'true',
                    'done-fn': 'onCurrencyConversionDone'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/addCard/route.js
// module id = ./components/xo-guest-components/src/multistep-signup/addCard/route.js
// module chunks = 1